@if (decoration()) {
  <div class="card-decoration">
    {{ decoration() }}
  </div>
}

<!-- Heading -->
<header class="card-icon-top">
  <app-icon [icon]="icon()"></app-icon>
</header>

<!-- Body -->
<div class="card-body">
  <div class="card-title">
    <strong> {{ _title() }} </strong>
  </div>

  <div class="card-subtitle">
    {{ updateDatetime() | date }}
    <div class="text-muted">
      {{ subText() | titlecase }}
    </div>
  </div>
</div>
